import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetScheduleSyncEvent } from "../../../store/ScheduleSync/ScheduleSyncEventAction";
import StatusCode from "../../../util/StatusCode";
import TableVertical from "../../misc/TableVertical";
import * as Helper from '../../../util/Helper';
import { ScheduleSync_CoreEvent } from "../../../models/CoreScheduleSyncModels";
import { RequestState } from "../../../models/RequestState";
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/store";


const ScheduleSyncEventInfo = () => {
    const { t } = useTranslation(['common', 'scheduleSync']);
    const { eventId } = useParams();
    const dispatch = useDispatch();
    const event = useSelector<RootState, RequestState<ScheduleSync_CoreEvent>>(state => state.schedulesync_events.event);

    useEffect(() => {
        if (eventId) {
            GetScheduleSyncEvent(eventId)(dispatch);
        }
    }, [dispatch, eventId]);

    const renderInfo = () => {
        let info = [];

        if (event.code === StatusCode.COMPLETE) {
            const e = event.data;
            info.push(
                { header: t('commonTableHeaders.title', {ns: 'scheduleSync'}), content: e.title },
                { header: t('genericTableHeaders.active', {ns: 'common'}), content: Helper.active(e.active) },
                { header: t('commonTableHeaders.startTime', { ns: 'scheduleSync' }), content: Helper.formatDate(e.startTime) },
                { header: t('commonTableHeaders.endTime', { ns: 'scheduleSync' }), content: Helper.formatDate(e.endTime) },
                { header: t('commonTableHeaders.location', { ns: 'scheduleSync' }), content: e.location },
                { header: t('genericTableHeaders.school', { ns: 'common' }), content: e.schoolName },
                { header: t('event.tableHeaders.externalId', { ns: 'scheduleSync' }), content: e.externalId },
                { header: t('genericTableHeaders.created', { ns: 'common' }), content: Helper.formatDate(e.created) },
                { header: t('genericTableHeaders.modified', { ns: 'common' }), content: Helper.formatDate(e.lastModified) },
            )
        }

        return (
            <TableVertical
                header={t('commonTableHeaders.information', {ns: 'scheduleSync'})}
                info={info}
                error={event.code === StatusCode.ERROR}
                searching={event.code === StatusCode.PENDING}
            />
        )
    }

    return (<>
        {renderInfo()}
    </>)
}

export default ScheduleSyncEventInfo;
